import Model from "./Model";

export default class ComponentEnvVariable extends Model {

    constructor(props) {

        super({});

        this.setDefaultValues({
            key: '',
            value: '',
        }, props);
    }
}
